Vue.component("average-ratings", {
    props: ["average", "ratings_by_source", " ratings_by_travel_composition"],
    template: `
		<div class="average-ratings">
			<div class="number-center">
				<div v-if="! active_source">
					<span class="number-xl">{{ average }}</span>
					<p class="light-text">{{ __('Average Rating') }}</p>
				</div>
				<div v-else>
					<span class="number-xl">{{ sourceAverage }}</span>
					<p class="light-text">{{ sourceLabelFromSlug(active_source) }}</p>
				</div>
			</div>
			
		</div>
	`,

    data() {
        return {
            colors: {
                trip_advisor: "#00BD88",
                booking_com: "#29377F",
                google: "#F5C000",
                expedia: "#2B2C63",
                hotels_com: "#DB001D",
                airbnb: "#FF3053",
                facebook_pages: "#4A409E",
                agoda: "#FDA000"
            },
            active_source: null
        };
    },

    computed: {
        sourceAverage() {
            if (this.ratings_by_source.hasOwnProperty(this.active_source)) {
                return this.ratings_by_source[this.active_source].average;
            }

            return 0;
        }
    },

    mounted() {
        // this.prepareChart()

        let instance = this;

        this.$eventHub.$on("updateCharts", val => {
            Vue.nextTick(function() {
                instance.updateChartData();
            });
        });
    },

    methods: {
        prepareChart() {
            let area = this.$refs.average_ratings_chart;
            let instance = this;

            this.chart = new Chart(area, {
                type: "doughnut",
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: "Total Reviews",
                            data: [],
                            backgroundColor: []
                        }
                    ]
                },
                options: {
                    legend: {
                        display: false
                    },
                    responsive: false,
                    cutoutPercentage: 70,
                    tooltips: {
                        enabled: false,
                        intersect: true,

                        custom: function(tooltipModel) {
                            if (tooltipModel.body) {
                                let index = tooltipModel.dataPoints[0].index;
                                let slug = instance.chart.data.labels[index];

                                // Avoid emitting multiple events
                                if (instance.active_source == slug) {
                                    return;
                                }

                                instance.active_source = slug;
                                instance.$parent.$emit(
                                    "setGroupOverviewActiveSource",
                                    instance.active_source
                                );
                                // instance.$eventHub.$emit('setGroupOverviewActiveSource', instance.active_source)
                            } else {
                                instance.active_source = null;
                                instance.$parent.$emit(
                                    "setGroupOverviewActiveSource",
                                    null
                                );
                            }
                        }
                    }
                }
            });

            this.updateChartData();
        },
        updateChartData() {
            if (!this.chart) return;

            this.chart.data.labels = Object.keys(this.ratings_by_source);
            this.chart.data.datasets[0].data = [];
            this.chart.data.datasets[0].backgroundColor = [];

            for (source in this.ratings_by_source) {
                if (source in this.colors) {
                    this.chart.data.datasets[0].backgroundColor.push(
                        this.colors[source]
                    );
                } else {
                    this.chart.data.datasets[0].backgroundColor.push("#e4e4e4");
                }

                this.chart.data.datasets[0].data.push(
                    this.ratings_by_source[source].count
                );
            }

            this.chart.update();
        }
    }
});
